// extracted by mini-css-extract-plugin
module.exports = {"body":"Home3BriefPopover_body__JPZHU","close":"Home3BriefPopover_close__fL1bx"};